export default __webpack_public_path__ + "static/media/Vector.6f124e54.svg";